export default __webpack_public_path__ + "f2f749dd6429c4c8944496504dffd380.gif";